export default __webpack_public_path__ + "static/media/8_2.c352e07e.jpg";